export default "__VITE_ASSET__a260356e__"